export default __webpack_public_path__ + "images/MR.520c10d.png";